<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Create an Account</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="10px"></div>

  <div fxLayout="row" fxLayoutGap="50px">
    <div fxFlex="grow">
      <div appMargin marginB="20px" class="text">
        Please complete the form below to proceed
      </div>

      <!-- <form class="ui large form" [formGroup]="detailForm" [ngClass]="{'loading': pending }">
				<div class="required field" appMargin marginB="30px">
					<label for="">What is your company ownerhip type</label>
					<div class="grouped fields">
					<div class="field">
					  <div class="ui radio checkbox checked">
						<input type="radio" name="list" checked="" tabindex="0" class="hidden">
						<label>Nigerian Owned <i class="question circle outline icon"></i></label>
					  </div>
					</div>
					<div class="field">
					  <div class="ui radio checkbox">
						<input type="radio" name="list" tabindex="0" class="hidden">
						<label>Nigerian Company Owned by Foreign Company <i class="question circle outline icon"></i></label>
					  </div>
					</div>
					<div class="field">
					  <div class="ui radio checkbox">
						<input type="radio" name="list" tabindex="0" class="hidden">
						<label>Foreign Owned <i class="question circle outline icon"></i></label>
					  </div>
					</div>
					</div>
				  </div>




				<div class="required field" appMargin marginB="30px">
					<label>Company RC/BN Number </label>
					 <small>Please enter only numbers, other characters are not allowed</small>
					<input type="text" name="rcNumber" placeholder="e.g. 1234567">
				  </div>
				  <div class="required field" appMargin marginB="30px">
					<label>Company Tax Identification Number </label>
					 <small>This is a unique number allocated and issues to your company by FIRS as a duly registered Tax Payer in Nigeria.</small>
					<input type="text" name="idNumber" placeholder="e.g. 05002743-0001">
				  </div>

				  <div class="field" appMargin marginB="30px">
					<label>License Number issued by NCC</label>
					 <small>If you applied and was issued a License by NCC, please enter your License number below </small>
					<input type="text" name="license" placeholder="e.g. 1234567">
				  </div>

				  <div class="ui box segment" fxLayout="row" fxLayoutAlign="space-between center" id="section" routerLink="/home-page/account/payment">
					<div fxFlex>
							<i class="arrow right  colored primary icon"></i>
					</div>
					<div>
						<button class="ui primary button">Proceed</button>
					</div>
				</div>

		</form> -->

      <div
        class="ui form"
        [formGroup]="detailForm"
        [ngClass]="{ loading: pending }"
      >
        <div class="field" [ngClass]="displayFieldCss('ownership_type')">
          <label>What is your company ownership type</label>
          <div class="grouped fields">
            <div
              appMargin
              marginB="1"
              class="field required"
              *ngFor="let optionx of ownershipType"
            >
              <div (click)="toggleCollapse(optionx)">
                <label>
                  <input
                    type="radio"
                    formControlName="ownership_type"
                    [value]="optionx.optionId"
                  />
                  {{ optionx.optionName }}
                </label>
                <i
                  class="question circle outline icon"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  [popupText]="optionx.optionDescription"
                ></i>
              </div>
              <!-- <small class="option-help">{{optionx.optionDescription}}</small> -->
            </div>
            <app-field-error-display
              [displayError]="isFieldValid('ownership_type')"
              errorMsg="Please select company ownership type"
            >
            </app-field-error-display>
          </div>
        </div>
        <div [suiCollapse]="collapse">
          <div class="field" [ngClass]="displayFieldCss('company_type')">
            <label>What is your company type</label>
            <div class="grouped fields">
              <div
                appMargin
                marginB="1"
                class="field required"
                *ngFor="let optionx of companyType"
              >
                <div (click)="toggleCollapsex(optionx)">
                  <label>
                    <input
                      type="radio"
                      formControlName="company_type"
                      [value]="optionx.optionId"
                    />
                    {{ optionx.optionName }}
                  </label>
                  <i
                    class="question circle outline icon"
                    suiPopup
                    [popupInverted]="true"
                    popupPlacement="bottom"
                    [popupText]="optionx.optionDescription"
                  ></i>
                </div>
                <!-- <small class="option-help"> {{optionx.optionDescription}}</small> -->
              </div>
              <app-field-error-display
                [displayError]="isFieldValid('company_type')"
                errorMsg="Please select company type"
              >
              </app-field-error-display>
            </div>
          </div>
        </div>
        <ng-template [ngIf]="collapseForeign">
          <div class="field required" [ngClass]="displayFieldCss('rc_number')">
            <label>Company RC/BN Number</label>
            <small
              >(Please enter only number, other characters are not
              allowed.)</small
            >
            <input
              type="text"
              placeholder="eg: 8962110"
              [(ngModel)]="userObject.rcNumber"
              formControlName="rc_number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('rc_number')"
              errorMsg="Please enter company RC Number"
            >
            </app-field-error-display>
          </div>

          <div
            *ngIf="isCountryName"
            class="field required"
            [ngClass]="displayFieldCss('companyName')"
          >
            <label>Company Name</label>
            <input
              type="text"
              formControlName="companyName"
              placeholder="Enter  company name"
            />
            <app-field-error-display
              [displayError]="isFieldValid('companyName')"
              errorMsg="Please enter  company name"
            >
            </app-field-error-display>
          </div>

          <div class="field required" [ngClass]="displayFieldCss('tin_number')">
            <label>Company Tax Identification Number</label>
            <small
              >(This is a unique number allocated and issued to your company by
              FIRS as a duly registered Taxpayer in Nigeria .)</small
            >
            <input
              type="text"
              placeholder="eg: 05002743-0001"
              [(ngModel)]="userObject.tinNumber"
              formControlName="tin_number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('tin_number')"
              errorMsg="Please enter company TIN Number"
            >
            </app-field-error-display>
          </div>
        </ng-template>

        <div [suiCollapse]="collapseForeign" [formGroup]="foreignForm">
          <div
            class="field required"
            [ngClass]="displayForeignFieldCss('companyName')"
          >
            <label>Company Name</label>
            <input
              type="text"
              formControlName="companyName"
              placeholder="Enter  company name"
            />
            <app-field-error-display
              [displayError]="isForeignFieldValid('companyName')"
              errorMsg="Please enter  company name"
            >
            </app-field-error-display>
          </div>
          <div
            class="field required"
            [ngClass]="displayForeignFieldCss('registrationNumber')"
          >
            <label>Company Registration Number</label>
            <input
              type="text"
              formControlName="registrationNumber"
              placeholder="Enter  company registration number"
            />
            <app-field-error-display
              [displayError]="isForeignFieldValid('registrationNumber')"
              errorMsg="Please enter  company registration number"
            >
            </app-field-error-display>
          </div>
          <div class="field required">
            <label>Third Party Business Information Provider</label>
            <div
              class="field required"
              [ngClass]="displayForeignFieldCss('thirdPartyBusinessName')"
            >
              <sui-select
                class="selection"
                placeholder="Select Third Party Business Provider"
                formControlName="thirdPartyBusinessName"
                [options]="bizProvider"
                labelField="optionName"
                [isSearchable]="true"
                #bizState
              >
                <sui-select-option
                  *ngFor="let option of bizState.filteredOptions"
                  [value]="option"
                >
                </sui-select-option>
              </sui-select>
            </div>
            <app-field-error-display
              [displayError]="isForeignFieldValid('thirdPartyBusinessName')"
              errorMsg="Please select business information provider"
            >
            </app-field-error-display>
          </div>

          <div
            class="field required"
            [ngClass]="displayForeignFieldCss('thirdPartyBusinessNumber')"
          >
            <label>Third Party Business Information Provider Id</label>
            <input
              type="text"
              formControlName="thirdPartyBusinessNumber"
              placeholder="Enter business information provider Id"
            />
            <app-field-error-display
              [displayError]="isForeignFieldValid('thirdPartyBusinessNumber')"
              errorMsg="Please enter business information provider Id"
            >
            </app-field-error-display>
          </div>
        </div>

        <div class="field">
          <label>License Number issued by NCC</label>
          <small
            >If you applied and was issued a License by NCC, please enter your
            License number below
          </small>
          <input
            formControlName="nccId"
            type="text"
            name="license"
            placeholder="e.g. 1234567"
          />
        </div>
      </div>

      <div
        class="ui box segment"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        id="section"
      >
        <div fxFlex (click)="goBack()">
          <i class="arrow left colored primary icon"></i>
        </div>
        <div>
          <button class="ui primary button" (click)="nextDynamic()">
            Proceed
          </button>
        </div>
      </div>
    </div>

    <div
      fxFlex="35%"
      appPadding
      paddingT="0"
      fxLayout="column"
      class="ui vertical basic segment"
      [ngClass]="{ loading: mpending }"
    >
      <div class="side" appPadding="7">
        <div [innerHtml]="registrationSidebar"></div>
      </div>
    </div>
  </div>
</div>
